import axios from "axios";
import Cookies from "js-cookie";
import cookieService from "../services/cookieService";
import AppConstants from "../constants/AppConstants";
// import AuthConfig from '../utils/AuthConfig';

const base = process.env.REACT_APP_API_URL;
const ssoBeta = process.env.REACT_APP_API_SSO_URL;
const api = {};

api.signOut = async () => {
    const token = cookieService.get(AppConstants.CS_KEY.ACCESS_TOKEN);
    const config = {
        headers: {
            Authorization: `Bearer ${token}`,
        },
    };
    const result = await axios
        .post(`${ssoBeta}/auth/sign-out`, {}, config)
        .then((res) => res)
        .catch((err) => err.response);
    return result;
};
api.profile = async () => {
  const token = Cookies.get("_szatn");
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  const result = await axios
    .get(`${base}/customer/profile-edit`, config)
    .then((res) => res)
    .catch((err) => err.response);
  return result;
};
api.updateProfile = async (data) => {
  const token = Cookies.get("_szatn");
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  const result = await axios
    .post(`${base}/customer/profile-update`, data, config)
    .then((res) => res)
    .catch((err) => err.response);
  return result;
};
api.sendOTP = async (data) => {
  const result = await axios
    .post(`${base}/customer/password-reset-otp-send`, data)
    .then((res) => res)
    .catch((err) => err.response);
  return result;
};
api.verifyOTP = async (data) => {
  const result = await axios
    .post(`${base}/customer/otp-verification`, data)
    .then((res) => res)
    .catch((err) => err.response);
  return result;
};
api.resetPassword = async (data) => {
  const result = await axios
    .post(`${base}/customer/password-change`, data)
    .then((res) => res)
    .catch((err) => err.response);
  return result;
};
api.parks = async (params) => {
  const result = await axios
    .get(`${base}/v1/parks`, { params })
    .then((res) => res)
    .catch((err) => err.response);
  return result;
};
api.getPark = async (params) => {
  const result = await axios
    .get(`${base}/v1/parks/${params.id}`)
    .then((res) => res)
    .catch((err) => err.response);
  return result;
};
api.park = async (id) => {
  const result = await axios
    .get(`${base}/customer/park-details/${id}`)
    .then((res) => res)
    .catch((err) => err.response);
  return result;
};
api.packages = async (params) => {
  const result = await axios
    .get(`${base}/customer/packages`, { params })
    .then((res) => res)
    .catch((err) => err.response);
  return result;
};
api.entry = async (branch, params) => {
  const result = await axios
    .get(`${base}/customer/entry-tickets/${branch}`, { params })
    .then((res) => res)
    .catch((err) => err.response);
  return result;
};
api.handshake = async () => {
  const result = await axios
    .get(`${base}/v1/handshake`)
    .then((res) => res)
    .catch((err) => err.response);
  return result;
};
api.ride = async (branch, params) => {
  const result = await axios
    .get(`${base}/customer/ride-tickets/${branch}`, { params })
    .then((res) => res)
    .catch((err) => err.response);
  return result;
};
api.categories = async (params) => {
  const result = await axios
    .get(`${base}/customer/categories`, { params })
    .then((res) => res)
    .catch((err) => err.response);
  return result;
};
api.buyTicket = async (data) => {
  const token = Cookies.get("_szatn");
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  const result = await axios
    .post(`${base}/customer/buy/ticket`, data, config)
    .then((res) => res)
    .catch((err) => err.response);
  return result;
};
api.buyPackage = async (data) => {
  const token = Cookies.get("_szatn");
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  const result = await axios
    .post(`${base}/customer/buy/package`, data, config)
    .then((res) => res)
    .catch((err) => err.response);
  return result;
};
api.activeTicket = async () => {
  const token = Cookies.get("_szatn");
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  const result = await axios
    .get(`${base}/customer/ticket/active`, config)
    .then((res) => res)
    .catch((err) => err.response);
  return result;
};
api.expiredTicket = async () => {
  const token = Cookies.get("_szatn");
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  const result = await axios
    .get(`${base}/customer/ticket/expired`, config)
    .then((res) => res)
    .catch((err) => err.response);
  return result;
};
api.packageTickets = async (id) => {
  const token = Cookies.get("_szatn");
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  const result = await axios
    .get(`${base}/customer/ticket/package?id=${id}`, config)
    .then((res) => res)
    .catch((err) => err.response);
  return result;
};
api.payment = async (data) => {
  const token = Cookies.get("_szatn");
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  const result = await axios
    .post(`${base}/customer/payment`, data, config)
    .then((res) => res)
    .catch((err) => err.response);
  return result;
};
api.getMemberships = async (id) => {
  const token = Cookies.get("_szatn");
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  const result = await axios
    .get(`${base}/customer/memberships?branch=${id}`, config)
    .then((res) => res)
    .catch((err) => err.response);
  return result;
};
api.purchaseMembership = async (data) => {
  const token = Cookies.get("_szatn");
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  const result = await axios
    .post(`${base}/customer/buy/membership`, data, config)
    .then((res) => res)
    .catch((err) => err.response);
  return result;
};
api.getChildren = async () => {
  const token = Cookies.get("_szatn");
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  const result = await axios
    .get(`${base}/customer/children`, config)
    .then((res) => res)
    .catch((err) => err.response);
  return result;
};
api.updateChildren = async (id, data) => {
  const token = Cookies.get("_szatn");
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  const result = await axios
    .post(`${base}/customer/children/${id}/update`, data, config)
    .then((res) => res)
    .catch((err) => err.response);
  return result;
};
api.childrenMemberships = async (id) => {
  const token = Cookies.get("_szatn");
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  const result = await axios
    .get(`${base}/customer/children/${id}/membership`, config)
    .then((res) => res)
    .catch((err) => err.response);
  return result;
};
api.addChildren = async (data) => {
  const token = Cookies.get("_szatn");
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  const result = await axios
    .post(`${base}/customer/children`, data, config)
    .then((res) => res)
    .catch((err) => err.response);
  return result;
};
api.branchList = async () => {
  const token = Cookies.get("_szatn");
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  const result = await axios
    .get(`${base}/customer/list/branch`, config)
    .then((res) => res)
    .catch((err) => err.response);
  return result;
};
api.paymentInformation = async (data) => {
  const token = Cookies.get("_szatn");
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  const result = await axios
    .post(`${base}/payment/information`, data, config)
    .then((res) => res)
    .catch((err) => err.response);
  return result;
};
api.downloadTicket = async (bookingId) => {
  const token = Cookies.get("_szatn");
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
    responseType: "blob",
  };
  const result = await axios
    .get(`${base}/v1/ticket/download-ticket/${bookingId}`, config)
    .then((res) => res)
    .catch((err) => err.response);
  return result;
};
export default api;
